module.exports = __webpack_public_path__ + "img/g_q1.4ddcfc01.jpeg";